import PropTypes from 'prop-types';

import fetch from 'features/common/fetch';

import PKUrl from './PKUrl';

const { greqTaskPartnerLink } = fetch.constants.urls;

export const GREQTaskPartnerLink = ({ children, taskId, partnerId, muiLink = false }) => (
	<PKUrl url={greqTaskPartnerLink} fetchArgs={{ taskId, partnerId }} doNotPreloadIascLink muiLink={muiLink}>
		{children}
	</PKUrl>
);

GREQTaskPartnerLink.propTypes = {
	children: PropTypes.node,
	muiLink: PropTypes.bool,
	partnerId: PropTypes.number,
	taskId: PropTypes.number,
};

export default GREQTaskPartnerLink;
